
import React, { useState } from "react";
import Accordion from "./common/Accordion";
import ContactFormModal from "./ContactFormModal";
import RemoveOtherContactModal from "./common/RemoveOtherContactModal";
import { NavLink } from "react-router-dom";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const OtherContactsForm = ({
  otherContacts,
  companyName,
  refreshCustomerDetails,
  editPermissions
}) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showRemoveContactModal, setShowRemoveContactModal] = useState(false);
  const attribute_set_key = "contact";

  const oContactEditClicked = (contact) => {
    setSelectedContact(contact);
    setShowContactModal(true);
  };

  const onContactDeleteClicked = (contact) => {
    setSelectedContact(contact);
    setShowRemoveContactModal(true);
  };

  const onAddContactClicked = () => {
    if (!companyName) {
      toast.error("Please add company name before adding contacts.");
      return;
    }

    setSelectedContact(null);
    setShowContactModal(true);
  };

  const closeModal = () => {
    setShowContactModal(false);
    setSelectedContact(null);
  };

  const SingleContactRow = ({ contact }) => {
    return (
      <div className="row d-flex align-items-center panelother-flex">
        <div className="col-md-9 col-sm-12 col-xs-12">
          <div className="single-box">
            <div className="icon-box">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3334 14V12.6667C13.3334 11.9594 13.0524 11.2811 12.5523 10.781C12.0522 10.281 11.3739 10 10.6667 10H5.33335C4.62611 10 3.94783 10.281 3.44774 10.781C2.94764 11.2811 2.66669 11.9594 2.66669 12.6667V14"
                  stroke="#006EFA"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.99998 7.33333C9.47274 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 3.19391 9.47274 2 7.99998 2C6.52722 2 5.33331 3.19391 5.33331 4.66667C5.33331 6.13943 6.52722 7.33333 7.99998 7.33333Z"
                  fill="#006EFA"
                  stroke="#006EFA"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="only-text">
              <div className="bottom-text">
                <NavLink to={`/${attribute_set_key}/${contact.id}`} className="informDone">
                  {(contact.name || "").trim() || "NA"}
                </NavLink>
              </div>
              {/* <div className="top-text">{contact.designation}</div> */}
              <div className="last-text">
                <div>{contact.email || "NA"}</div>
                <div>{contact.phone_number || "NA"}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-12 col-xs-12 p-0">
          <ul className="d-flex list-style-none align-items-center justify-content-between mb-0">
            <li>
              <button
                className="ghost-button"
                onClick={() => oContactEditClicked(contact)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1390_14481)">
                    <path
                      d="M11.3333 2.00004C11.5083 1.82494 11.7162 1.68605 11.945 1.59129C12.1738 1.49653 12.419 1.44775 12.6666 1.44775C12.9142 1.44775 13.1594 1.49653 13.3882 1.59129C13.617 1.68605 13.8248 1.82494 13.9999 2.00004C14.175 2.17513 14.3139 2.383 14.4087 2.61178C14.5034 2.84055 14.5522 3.08575 14.5522 3.33337C14.5522 3.58099 14.5034 3.82619 14.4087 4.05497C14.3139 4.28374 14.175 4.49161 13.9999 4.66671L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2.00004Z"
                      stroke="#5C5F62"
                      strokeWidth="1.33"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1390_14481">
                      <rect width="16" height="16" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </li>
            <li>
              <button
                className="ghost-button"
                onClick={() => onContactDeleteClicked(contact)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Edit / Remove_Minus_Circle">
                    <path
                      id="Vector"
                      d="M8 12H16M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
                      stroke="#5C5F62"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const handleSave = (saveData) => {
    // Handle save logic here
    console.log("Saving contact:", saveData);
    refreshCustomerDetails();
    closeModal();
  };

  const ActionButton = () => {
    return (
      <React.Fragment>
        {
          editPermissions && (
            <button
              className="editprimary-btn editsecondry-btn"
              onClick={(e) => {
                e.stopPropagation();
                onAddContactClicked();
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 3.33331V12.6666"
                  stroke="#006EFA"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.33334 8H12.6667"
                  stroke="#006EFA"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {"Add"}
            </button>
          )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <Accordion
        header="Other Contact"
        targetID="otherContactsForm"
        fixedHeight={"400px"}
        actionButton={<ActionButton />}
      >
        <div className="panel-other">
          <div className="other-contacts-list">
            {otherContacts && otherContacts.length > 0 ? (
              otherContacts.map((contact, index) => (
                <React.Fragment key={index}>
                  <SingleContactRow contact={contact} />
                  {index !== otherContacts.length - 1 && (
                    <div className="seperator"></div>
                  )}
                </React.Fragment>
              ))
            ) : (
              <div className="row d-flex align-items-center panelother-flex no-contacts">
                No other contacts available
              </div>
            )}
          </div>
          {/* <div className="button-add-new d-flex justify-content-end">
            <button className="add-new" onClick={onAddContactClicked}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 3.33331V12.6666"
                  stroke="white"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.33334 8H12.6667"
                  stroke="white"
                  strokeWidth="1.33"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Add New
            </button>
          </div> */}
        </div>
      </Accordion>
      <div>
        <ContactFormModal
          showContactModal={showContactModal}
          selectedContact={selectedContact}
          onSave={handleSave}
          closeModal={closeModal}
          companyName={companyName}
        />
        <RemoveOtherContactModal
          showModal={showRemoveContactModal}
          setShowModal={setShowRemoveContactModal}
          contactDetails={selectedContact}
          companyName={companyName}
          onSave={handleSave}
        />
      </div>
    </React.Fragment>
  );
};

export default OtherContactsForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/OtherContactsForm.js